import { Outlet, createBrowserRouter } from "react-router-dom";
import { RoutePath } from "./constants";
import Home from "./pages/home";
import { isAuthenticated } from "./loaders/authentication";
import DeleteAccountPage from "./pages/google-console";
import UserLayout from "./layout/user-layout";
import BookDetail from "./pages/book-detail";
import UserProfileLayout from "./layout/user-profile-layout";
import LibraryUser from "./pages/user/library-user";
import AccountUser from "./pages/user/account-user";
import TransactionUser from "./pages/user/transaction-user";
import RulesUser from "./pages/user/rules-user";
import SupportUser from "./pages/user/support-user";
import Search from "./pages/search";
import UpgradePage from "./pages/upgrade";
import BookByCategory from "./pages/book-by-category";
import BookByType from "./pages/book-by-type";
import Reading from "./pages/reading";
import EbookReading from "./pages/ebook-reading";
import ProductWarrantyPolicy from "./pages/product-warranty-policy";
import InformationSecurityPolicy from "./pages/information-security-policy";
import GoodsInspectionPolicy from "./pages/goods-inspection-policy";
import PaymentPolicy from "./pages/payment-policy";
import ShippingDeliveryPolicy from "./pages/shipping-delivery-policy";
import ComplaintHandlingPolicy from "./pages/complaint-handling-policy";
import AuthorList from "./pages/author-list";
import AuthorDetailPage from "./pages/author-detail";
import BookFavoriteList from "./pages/book-favorite-list";
import BookOption from "./pages/book-option";
import WalletUser from "./pages/user/wallet-user";
import VasOptionList from "./pages/user/vas-option-list";
import VasQrInfo from "./pages/user/vas-qr";
import AffiliateUser from "./pages/user/affiliate-user/affiliate-user.page";

const router = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        path: "",
        element: <UserLayout />,
        children: [
          {
            path: RoutePath.HOME,
            element: <Home />,
          },
          {
            path: RoutePath.SEARCH,
            element: <Search />,
          },
          {
            path: RoutePath.BOOK_BY_CATEGORY,
            element: <BookByCategory />,
          },
          {
            path: RoutePath.BOOK_BY_OPTION,
            element: <BookOption />,
          },
          {
            path: RoutePath.BOOK_BY_TYPE,
            element: <BookByType />,
          },
          {
            path: RoutePath.BOOK_DETAIL_ID,
            element: <BookDetail />,
          },
          {
            path: RoutePath.UPGRADE,
            element: <UpgradePage />,
          },
          {
            path: RoutePath.USER_PROFILE,
            loader: isAuthenticated,
            element: <UserProfileLayout />,
            children: [
              {
                path: "",
                element: <Outlet />,
                children: [
                  {
                    path: RoutePath.USER_ACCOUNT,
                    element: <AccountUser />,
                  },
                  {
                    path: RoutePath.USER_LIBRARY,
                    element: <LibraryUser />,
                  },
                  {
                    path: RoutePath.USER_WALLET,
                    element: <WalletUser />,
                  },
                  {
                    path: RoutePath.USER_AFFILIATE,
                    element: <AffiliateUser />,
                  },
                  {
                    path: RoutePath.USER_TRANSACTION,
                    element: <TransactionUser />,
                  },
                  {
                    path: RoutePath.USER_RULES,
                    element: <RulesUser />,
                  },
                  {
                    path: RoutePath.USER_POLICIES,
                    element: <SupportUser />,
                  },
                ],
              },
            ],
          },
          {
            path: RoutePath.AUTHOR,
            element: <AuthorList />,
          },
          {
            path: RoutePath.AUTHOR_DETAIL,
            element: <AuthorDetailPage />,
          },
          {
            path: RoutePath.BOOK_CATEGORY_FAVORITE,
            element: <BookFavoriteList />,
          },
          {
            path: RoutePath.VAS_OPTION_LIST,
            element: <VasOptionList />,
          },
          {
            path: RoutePath.VAS_OPTION_QR,
            element: <VasQrInfo />,
          },
        ],
      },
    ],
  },
  {
    path: RoutePath.READING_ID,
    loader: isAuthenticated,
    element: <Reading />,
  },
  {
    path: RoutePath.EBOOK_READING_ID,
    loader: isAuthenticated,
    element: <EbookReading />,
  },
  // {
  //   path: RoutePath.SIGN_IN,
  //   element: <SignIn />,
  //   loader: isAuthenticated,
  // },
  // {
  //   path: RoutePath.SIGN_UP,
  //   element: <SignUp />,
  //   loader: isAuthenticated,
  // },
  // {
  //   path: RoutePath.RULE,
  //   element: <Rules />,
  // },
  // {
  //   path: RoutePath.POLICY,
  //   element: <Policy />,
  // },
  {
    path: RoutePath.PRODUCT_WARRANTY_POLICY,
    element: <ProductWarrantyPolicy />,
  },
  {
    path: RoutePath.INFORMATION_SECURITY_POLICY,
    element: <InformationSecurityPolicy />,
  },
  {
    path: RoutePath.GOODS_INSPECTION_POLICY,
    element: <GoodsInspectionPolicy />,
  },
  {
    path: RoutePath.PAYMENT_POLICY,
    element: <PaymentPolicy />,
  },
  {
    path: RoutePath.SHIPPING_DELIVERY_POLICY,
    element: <ShippingDeliveryPolicy />,
  },
  {
    path: RoutePath.COMPLAINT_HANDLING_POLICY,
    element: <ComplaintHandlingPolicy />,
  },
  {
    path: RoutePath.GOOGLE_CONSOLE,
    children: [
      {
        path: "delete",
        element: <DeleteAccountPage />,
      },
    ],
  },
  {
    path: "*",
    element: <>Not Found</>,
  },
]);

export default router;
